import React, { useState, useEffect, Fragment } from 'react';
import {
    Card,
    CardBody,
    CardImg,
    ButtonGroup,
    Button,
    Row,
    Modal,
    ModalHeader,
    CustomInput,
    InputGroupAddon,
    InputGroupText,
    Input,
    ModalBody,
    InputGroup,
} from 'reactstrap';
import { ChromePicker } from 'react-color'
import {
    Separator,
    Colxx,
} from '../../../../../../components/common/CustomBootstrap';

import {
    colorBlockStlye,
    SelectStyle,
    editingStlyeWithoutBackGround,
    InputStlye,
    setBackGroundColor,
} from '../../style/DigitalAssistantStyle';
import ImageGallery from '../../../propinfo/gallery/index';
import FontsList from '../FontsList';
import { getGroupID } from '../../../../../../helpers/AxiosAPI';

export default function EmbedDigitalAssistant({ embedPage, saveIntegration, integrationId }) {
    /** Avatar state */
    const [isSelected, setIsSelected] = useState({
        Jenni: false,
        Novi: false,
        Bob: false,
        Sarah: false,
        Wallis: false,
    });
    const [avatarLink, setAvatarLink] = useState('');
    const [arrowType, setArrowType] = useState(embedPage.arrowType);
    const [arrowSize, setArrowSize] = useState(embedPage.arrowSize);
    const [arrowColor, setArrowColor] = useState(embedPage.arrowColor);
    const [displayServices, setDisplayServices] = useState(embedPage.displayServices);
    const [isFooterHide, setIsFooterHide] = useState(embedPage.isFooterHide);
    const [font, setFont] = useState(embedPage.font === null ? "" : embedPage.font);
    const [galleryVisible, setGalleryVisible] = useState(false);
    /** other Digital Assistant state */
    const [edit, setEdit] = useState(true);
    let [setting, setSetting] = useState(embedPage);
    const [error, setError] = useState(true);

    let [iseditMode, setEditMode] = useState({
        'title': false,
        'subTitle': false,
        'arrow': false,
        'primaryColor': false,
        'buttonColor': false,
        'redeemBar': false,
        'redeemButton': false,
        'buttonTextColor': false,
        'redeemTextColor': false,
        'shoppingBar': false,
        'shoppingBarText': false,
    });
    const [fontsList, setFontsList] = useState(embedPage.fonts || {
        'title': '',
        'subTitle': '',
        'serviceTitle': '',
        'serviceDescription': '',
        'website': '',
        'buttonText': '',
        'voucherDescription': '',
        'voucherTitle': ''
    });
    const handleSave = () => {
        setEdit(!edit);
        setting.colours = setting.colours;
        setting.isFooterHide = isFooterHide;
        setting.font = font;
        setting.arrowType = arrowType;
        setting.arrowSize = arrowSize;
        setting.arrowColor = arrowColor;
        setting.displayServices = displayServices;
        setting.fonts = fontsList;
        saveIntegration({ PageSettings: setting });
    };

    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        setAvatarLink(image.src);
        setSetting({
            ...setting,
            name: image.caption,
        });
    };
    const SetClose = () => {
        setEditMode({
            'title': false,
            'subTitle': false,
            'arrow': false,
            'primaryColor': false,
            'buttonColor': false,
            'redeemBar': false,
            'redeemButton': false,
            'buttonTextColor': false,
            'redeemTextColor': false,
            'shoppingBar': false,
            'shoppingBarText': false,
        });
    };
    const CloseColorBox = (event) => {
        if ((iseditMode.title === true || iseditMode.arrow === true ||
            iseditMode.subTitle === true || iseditMode.primaryColor === true || iseditMode.buttonColor === true || iseditMode.redeemBar === true
            || iseditMode.redeemButton === true || iseditMode.buttonTextColor === true ||
            iseditMode.shoppingBar === true || iseditMode.shoppingBarText === true)) {
            SetClose();

        }
    };

    const handleColoursReset = () => {
        setSetting({
            ...setting, colours: {
                primaryColor: '#E31B78',
                buttonColor: '#033DA5',
                redeemBar: '#FA8DAB',
                redeemButton: '#F5D2E3',
                buttonTextColor: 'white',
                redeemTextColor: 'black',
                shoppingBar: '#ED187B',
                shoppingBarText: 'white'
            }
        });
    };
    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={'avatar'}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    return (
        <Fragment>
            {setting ? (
                <Card>
                    <CardBody name="bodyClick" onClick={(e) => { CloseColorBox(e); }}>
                        <div className="text-center">
                            <h6>Embed Page Appearance</h6>
                            <Separator className="mb-3" />


                            <div className="my-2 mt-3 text-center"><b>Font Settings</b></div>

                            {/* <div className="mb-1 text-center">
                                <b>Font Name </b>
                                <br />
                                <select
                                    name="Font Name"
                                    type='select'
                                    style={InputStlye}
                                    defaultValue={embedPage.font}
                                    onChange={(e) => setFont(e.target.value)}
                                >

                                    <option value='Academy Engraved LET' style={{ fontFamily: 'Academy Engraved LET' }}>Academy Engraved LET </option>

                                    <option value='AcademyEngravedLetPlain' style={{ fontFamily: 'AcademyEngravedLetPlain' }}>AcademyEngravedLetPlain </option>

                                    <option value='Al Nile' style={{ fontFamily: 'Al Nile' }}>Al Nile </option>

                                    <option value='AlNile-Bold' style={{ fontFamily: 'AlNile-Bold' }}>AlNile-Bold </option>

                                    <option value='American Typewriter' style={{ fontFamily: 'American Typewriter' }}>American Typewriter </option>

                                    <option value='AmericanTypewriter-Bold' style={{ fontFamily: 'AmericanTypewriter-Bold' }}>AmericanTypewriter-Bold </option>

                                    <option value='AmericanTypewriter-Condensed' style={{ fontFamily: 'AmericanTypewriter-Condensed' }}>AmericanTypewriter-Condensed </option>

                                    <option value='AmericanTypewriter-CondensedBold' style={{ fontFamily: 'AmericanTypewriter-CondensedBold' }}>AmericanTypewriter-CondensedBold </option>

                                    <option value='AmericanTypewriter-CondensedLight' style={{ fontFamily: 'AmericanTypewriter-CondensedLight' }}>AmericanTypewriter-CondensedLight </option>

                                    <option value='AmericanTypewriter-Light' style={{ fontFamily: 'AmericanTypewriter-Light' }}>AmericanTypewriter-Light </option>

                                    <option value='Apple Color Emoji' style={{ fontFamily: 'Apple Color Emoji' }}>Apple Color Emoji </option>

                                    <option value='Apple SD Gothic Neo' style={{ fontFamily: 'Apple SD Gothic Neo' }}>Apple SD Gothic Neo </option>

                                    <option value='AppleColorEmoji' style={{ fontFamily: 'AppleColorEmoji' }}>AppleColorEmoji </option>

                                    <option value='AppleSDGothicNeo-Bold' style={{ fontFamily: 'AppleSDGothicNeo-Bold' }}>AppleSDGothicNeo-Bold </option>

                                    <option value='AppleSDGothicNeo-Light' style={{ fontFamily: 'AppleSDGothicNeo-Light' }}>AppleSDGothicNeo-Light </option>

                                    <option value='AppleSDGothicNeo-Medium' style={{ fontFamily: 'AppleSDGothicNeo-Medium' }}>AppleSDGothicNeo-Medium </option>

                                    <option value='AppleSDGothicNeo-Regular' style={{ fontFamily: 'AppleSDGothicNeo-Regular' }}>AppleSDGothicNeo-Regular </option>

                                    <option value='AppleSDGothicNeo-SemiBold' style={{ fontFamily: 'AppleSDGothicNeo-SemiBold' }}>AppleSDGothicNeo-SemiBold </option>

                                    <option value='AppleSDGothicNeo-Thin' style={{ fontFamily: 'AppleSDGothicNeo-Thin' }}>AppleSDGothicNeo-Thin </option>

                                    <option value='AppleSDGothicNeo-UltraLight' style={{ fontFamily: 'AppleSDGothicNeo-UltraLight' }}>AppleSDGothicNeo-UltraLight </option>

                                    <option value='Arial' style={{ fontFamily: 'Arial' }}>Arial </option>

                                    <option value='Arial Hebrew' style={{ fontFamily: 'Arial Hebrew' }}>Arial Hebrew </option>

                                    <option value='Arial Rounded MT Bold' style={{ fontFamily: 'Arial Rounded MT Bold' }}>Arial Rounded MT Bold </option>

                                    <option value='Arial-BoldItalicMT' style={{ fontFamily: 'Arial-BoldItalicMT' }}>Arial-BoldItalicMT </option>

                                    <option value='Arial-BoldMT' style={{ fontFamily: 'Arial-BoldMT' }}>Arial-BoldMT </option>

                                    <option value='Arial-ItalicMT' style={{ fontFamily: 'Arial-ItalicMT' }}>Arial-ItalicMT </option>

                                    <option value='ArialHebrew' style={{ fontFamily: 'ArialHebrew' }}>ArialHebrew </option>

                                    <option value='ArialHebrew-Bold' style={{ fontFamily: 'ArialHebrew-Bold' }}>ArialHebrew-Bold </option>

                                    <option value='ArialHebrew-Light' style={{ fontFamily: 'ArialHebrew-Light' }}>ArialHebrew-Light </option>

                                    <option value='ArialMT' style={{ fontFamily: 'ArialMT' }}>ArialMT </option>

                                    <option value='ArialRoundedMTBold' style={{ fontFamily: 'ArialRoundedMTBold' }}>ArialRoundedMTBold </option>

                                    <option value='Avenir' style={{ fontFamily: 'Avenir' }}>Avenir </option>

                                    <option value='Avenir Next' style={{ fontFamily: 'Avenir Next' }}>Avenir Next </option>

                                    <option value='Avenir Next Condensed' style={{ fontFamily: 'Avenir Next Condensed' }}>Avenir Next Condensed </option>

                                    <option value='Avenir-Black' style={{ fontFamily: 'Avenir-Black' }}>Avenir-Black </option>

                                    <option value='Avenir-BlackOblique' style={{ fontFamily: 'Avenir-BlackOblique' }}>Avenir-BlackOblique </option>

                                    <option value='Avenir-Book' style={{ fontFamily: 'Avenir-Book' }}>Avenir-Book </option>

                                    <option value='Avenir-BookOblique' style={{ fontFamily: 'Avenir-BookOblique' }}>Avenir-BookOblique </option>

                                    <option value='Avenir-Heavy' style={{ fontFamily: 'Avenir-Heavy' }}>Avenir-Heavy </option>

                                    <option value='Avenir-HeavyOblique' style={{ fontFamily: 'Avenir-HeavyOblique' }}>Avenir-HeavyOblique </option>

                                    <option value='Avenir-Light' style={{ fontFamily: 'Avenir-Light' }}>Avenir-Light </option>

                                    <option value='Avenir-LightOblique' style={{ fontFamily: 'Avenir-LightOblique' }}>Avenir-LightOblique </option>

                                    <option value='Avenir-Medium' style={{ fontFamily: 'Avenir-Medium' }}>Avenir-Medium </option>

                                    <option value='Avenir-MediumOblique' style={{ fontFamily: 'Avenir-MediumOblique' }}>Avenir-MediumOblique </option>

                                    <option value='Avenir-Oblique' style={{ fontFamily: 'Avenir-Oblique' }}>Avenir-Oblique </option>

                                    <option value='Avenir-Roman' style={{ fontFamily: 'Avenir-Roman' }}>Avenir-Roman </option>

                                    <option value='AvenirNext-Bold' style={{ fontFamily: 'AvenirNext-Bold' }}>AvenirNext-Bold </option>

                                    <option value='AvenirNext-BoldItalic' style={{ fontFamily: 'AvenirNext-BoldItalic' }}>AvenirNext-BoldItalic </option>

                                    <option value='AvenirNext-DemiBold' style={{ fontFamily: 'AvenirNext-DemiBold' }}>AvenirNext-DemiBold </option>

                                    <option value='AvenirNext-DemiBoldItalic' style={{ fontFamily: 'AvenirNext-DemiBoldItalic' }}>AvenirNext-DemiBoldItalic </option>

                                    <option value='AvenirNext-Heavy' style={{ fontFamily: 'AvenirNext-Heavy' }}>AvenirNext-Heavy </option>

                                    <option value='AvenirNext-HeavyItalic' style={{ fontFamily: 'AvenirNext-HeavyItalic' }}>AvenirNext-HeavyItalic </option>

                                    <option value='AvenirNext-Italic' style={{ fontFamily: 'AvenirNext-Italic' }}>AvenirNext-Italic </option>

                                    <option value='AvenirNext-Medium' style={{ fontFamily: 'AvenirNext-Medium' }}>AvenirNext-Medium </option>

                                    <option value='AvenirNext-MediumItalic' style={{ fontFamily: 'AvenirNext-MediumItalic' }}>AvenirNext-MediumItalic </option>

                                    <option value='AvenirNext-Regular' style={{ fontFamily: 'AvenirNext-Regular' }}>AvenirNext-Regular </option>

                                    <option value='AvenirNext-UltraLight' style={{ fontFamily: 'AvenirNext-UltraLight' }}>AvenirNext-UltraLight </option>

                                    <option value='AvenirNext-UltraLightItalic' style={{ fontFamily: 'AvenirNext-UltraLightItalic' }}>AvenirNext-UltraLightItalic </option>

                                    <option value='AvenirNextCondensed-Bold' style={{ fontFamily: 'AvenirNextCondensed-Bold' }}>AvenirNextCondensed-Bold </option>

                                    <option value='AvenirNextCondensed-BoldItalic' style={{ fontFamily: 'AvenirNextCondensed-BoldItalic' }}>AvenirNextCondensed-BoldItalic </option>

                                    <option value='AvenirNextCondensed-DemiBold' style={{ fontFamily: 'AvenirNextCondensed-DemiBold' }}>AvenirNextCondensed-DemiBold </option>

                                    <option value='AvenirNextCondensed-DemiBoldItalic' style={{ fontFamily: 'AvenirNextCondensed-DemiBoldItalic' }}>AvenirNextCondensed-DemiBoldItalic </option>

                                    <option value='AvenirNextCondensed-Heavy' style={{ fontFamily: 'AvenirNextCondensed-Heavy' }}>AvenirNextCondensed-Heavy </option>

                                    <option value='AvenirNextCondensed-HeavyItalic' style={{ fontFamily: 'AvenirNextCondensed-HeavyItalic' }}>AvenirNextCondensed-HeavyItalic </option>

                                    <option value='AvenirNextCondensed-Italic' style={{ fontFamily: 'AvenirNextCondensed-Italic' }}>AvenirNextCondensed-Italic </option>

                                    <option value='AvenirNextCondensed-Medium' style={{ fontFamily: 'AvenirNextCondensed-Medium' }}>AvenirNextCondensed-Medium </option>

                                    <option value='AvenirNextCondensed-MediumItalic' style={{ fontFamily: 'AvenirNextCondensed-MediumItalic' }}>AvenirNextCondensed-MediumItalic </option>

                                    <option value='AvenirNextCondensed-Regular' style={{ fontFamily: 'AvenirNextCondensed-Regular' }}>AvenirNextCondensed-Regular </option>

                                    <option value='AvenirNextCondensed-UltraLight' style={{ fontFamily: 'AvenirNextCondensed-UltraLight' }}>AvenirNextCondensed-UltraLight </option>

                                    <option value='AvenirNextCondensed-UltraLightItalic' style={{ fontFamily: 'AvenirNextCondensed-UltraLightItalic' }}>AvenirNextCondensed-UltraLightItalic </option>


                                    <option value='Baskerville' style={{ fontFamily: 'Baskerville' }}>Baskerville </option>

                                    <option value='Baskerville-Bold' style={{ fontFamily: 'Baskerville-Bold' }}>Baskerville-Bold </option>

                                    <option value='Baskerville-BoldItalic' style={{ fontFamily: 'Baskerville-BoldItalic' }}>Baskerville-BoldItalic </option>

                                    <option value='Baskerville-Italic' style={{ fontFamily: 'Baskerville-Italic' }}>Baskerville-Italic </option>

                                    <option value='Baskerville-SemiBold' style={{ fontFamily: 'Baskerville-SemiBold' }}>Baskerville-SemiBold </option>

                                    <option value='Baskerville-SemiBoldItalic' style={{ fontFamily: 'Baskerville-SemiBoldItalic' }}>Baskerville-SemiBoldItalic </option>

                                    <option value='Bodoni 72 ' style={{ fontFamily: 'Bodoni 72' }}>Bodoni 72 </option>

                                    <option value='Bodoni 72 Oldstyle' style={{ fontFamily: 'Bodoni 72 Oldstyle' }}>Bodoni 72 Oldstyle </option>

                                    <option value='Bodoni 72 Smallcaps' style={{ fontFamily: 'Bodoni 72 Smallcaps' }}>Bodoni 72 Smallcaps </option>

                                    <option value='Bodoni Ornaments' style={{ fontFamily: 'Bodoni Ornaments' }}>Bodoni Ornaments </option>

                                    <option value='BodoniOrnamentsITCTT' style={{ fontFamily: 'BodoniOrnamentsITCTT' }}>BodoniOrnamentsITCTT </option>

                                    <option value='BodoniSvtyTwoITCTT-Bold' style={{ fontFamily: 'BodoniSvtyTwoITCTT-Bold' }}>BodoniSvtyTwoITCTT-Bold </option>

                                    <option value='BodoniSvtyTwoITCTT-Book' style={{ fontFamily: 'BodoniSvtyTwoITCTT-Book' }}>BodoniSvtyTwoITCTT-Book </option>

                                    <option value='BodoniSvtyTwoITCTT-BookIta' style={{ fontFamily: 'BodoniSvtyTwoITCTT-BookIta' }}>BodoniSvtyTwoITCTT-BookIta </option>

                                    <option value='BodoniSvtyTwoOSITCTT-Bold' style={{ fontFamily: 'BodoniSvtyTwoOSITCTT-Bold' }}>BodoniSvtyTwoOSITCTT-Bold </option>

                                    <option value='BodoniSvtyTwoOSITCTT-Book' style={{ fontFamily: 'BodoniSvtyTwoOSITCTT-Book' }}>BodoniSvtyTwoOSITCTT-Book </option>

                                    <option value='BodoniSvtyTwoSCITCTT-Book' style={{ fontFamily: 'BodoniSvtyTwoSCITCTT-Book' }}>BodoniSvtyTwoSCITCTT-Book </option>

                                    <option value='Bradley Hand' style={{ fontFamily: 'Bradley Hand' }}>Bradley Hand </option>

                                    <option value='BradleyHandITCTT-Bold' style={{ fontFamily: 'BradleyHandITCTT-Bold' }}>BradleyHandITCTT-Bold </option>

                                    <option value='Chalkboard SE' style={{ fontFamily: 'Chalkboard SE' }}>Chalkboard SE </option>

                                    <option value='ChalkboardSE-Bold' style={{ fontFamily: 'ChalkboardSE-Bold' }}>ChalkboardSE-Bold </option>

                                    <option value='ChalkboardSE-Light' style={{ fontFamily: 'ChalkboardSE-Light' }}>ChalkboardSE-Light </option>

                                    <option value='ChalkboardSE-Regular' style={{ fontFamily: 'ChalkboardSE-Regular' }}>ChalkboardSE-Regular </option>

                                    <option value='Chalkduster' style={{ fontFamily: 'Chalkduster' }}>Chalkduster </option>



                                    <option value='Copperplate' style={{ fontFamily: 'Copperplate' }}>Copperplate </option>

                                    <option value='Copperplate-Bold' style={{ fontFamily: 'Copperplate-Bold' }}>Copperplate-Bold </option>

                                    <option value='Copperplate-Light' style={{ fontFamily: 'Copperplate-Light' }}>Copperplate-Light </option>

                                    <option value='Courier' style={{ fontFamily: 'Courier' }}>Courier </option>

                                    <option value='Courier New' style={{ fontFamily: 'Courier New' }}>Courier New </option>

                                    <option value='Courier Bold' style={{ fontFamily: 'Courier-Bold' }}>Courier-Bold </option>

                                    <option value='Courier-BoldOblique' style={{ fontFamily: 'Courier-BoldOblique' }}>Courier-BoldOblique </option>

                                    <option value='Courier-Oblique' style={{ fontFamily: 'Courier-Oblique' }}>Courier-Oblique </option>

                                    <option value='CourierNewPS-BoldItalicMT' style={{ fontFamily: 'CourierNewPS-BoldItalicMT' }}>CourierNewPS-BoldItalicMT </option>

                                    <option value='CourierNewPS-BoldMT' style={{ fontFamily: 'CourierNewPS-BoldMT' }}>CourierNewPS-BoldMT </option>

                                    <option value='CourierNewPS-ItalicMT' style={{ fontFamily: 'CourierNewPS-ItalicMT' }}>CourierNewPS-ItalicMT </option>

                                    <option value='CourierNewPSMT' style={{ fontFamily: 'CourierNewPSMT' }}>CourierNewPSMT </option>

                                    <option value='Cursive' style={{ fontFamily: 'Cursive' }}>Cursive </option>

                                    <option value='Damascus' style={{ fontFamily: 'Damascus' }}>Damascus </option>

                                    <option value='DamascusBold' style={{ fontFamily: 'DamascusBold' }}>DamascusBold </option>

                                    <option value='DamascusLight' style={{ fontFamily: 'DamascusLight' }}>DamascusLight </option>

                                    <option value='DamascusMedium' style={{ fontFamily: 'DamascusMedium' }}>DamascusMedium </option>

                                    <option value='DamascusSemiBold' style={{ fontFamily: 'DamascusSemiBold' }}>DamascusSemiBold </option>



                                    <option value='Didot' style={{ fontFamily: 'Didot' }}>Didot </option>

                                    <option value='Didot-Bold' style={{ fontFamily: 'Didot-Bold' }}>Didot-Bold </option>

                                    <option value='Didot-Italic' style={{ fontFamily: 'Didot-Italic' }}>Didot-Italic </option>

                                    <option value='DiwanMishafi' style={{ fontFamily: 'DiwanMishafi' }}>DiwanMishafi </option>

                                    <option value='Euphemia UCAS' style={{ fontFamily: 'Euphemia UCAS' }}>Euphemia UCAS </option>

                                    <option value='EuphemiaUCAS-Bold' style={{ fontFamily: 'EuphemiaUCAS-Bold' }}>EuphemiaUCAS-Bold </option>

                                    <option value='EuphemiaUCAS-Italic' style={{ fontFamily: 'EuphemiaUCAS-Italic' }}>EuphemiaUCAS-Italic </option>

                                    <option value='Farah' style={{ fontFamily: 'Farah' }}>Farah </option>

                                    <option value='Futura' style={{ fontFamily: 'Futura' }}>Futura </option>

                                    <option value='Futura-CondensedExtraBold' style={{ fontFamily: 'Futura-CondensedExtraBold' }}>Futura-CondensedExtraBold </option>

                                    <option value='Futura-CondensedMedium' style={{ fontFamily: 'Futura-CondensedMedium' }}>Futura-CondensedMedium </option>

                                    <option value='Futura-Medium' style={{ fontFamily: 'Futura-Medium' }}>Futura-Medium </option>

                                    <option value='Futura-MediumItalic' style={{ fontFamily: 'Futura-MediumItalic' }}>Futura-MediumItalic </option>

                                    <option value='GeezaPro Pro' style={{ fontFamily: 'Geeza Pro' }}>Geeza Pro </option>

                                    <option value='GeezaPro-Bold' style={{ fontFamily: 'GeezaPro-Bold' }}>GeezaPro-Bold </option>

                                    <option value='Georgia' style={{ fontFamily: 'Georgia' }}>Georgia </option>

                                    <option value='Georgia-Bold' style={{ fontFamily: 'Georgia-Bold' }}>Georgia-Bold </option>

                                    <option value='Georgia-BoldItalic' style={{ fontFamily: 'Georgia-BoldItalic' }}>Georgia-BoldItalic </option>

                                    <option value='Georgia-Italic' style={{ fontFamily: 'Georgia-Italic' }}>Georgia-Italic </option>

                                    <option value='Gill Sans' style={{ fontFamily: 'Gill Sans' }}>Gill Sans </option>

                                    <option value='GillSans-Bold' style={{ fontFamily: 'GillSans-Bold' }}>GillSans-Bold </option>

                                    <option value='GillSans-BoldItalic' style={{ fontFamily: 'GillSans-BoldItalic' }}>GillSans-BoldItalic </option>

                                    <option value='GillSans-Italic' style={{ fontFamily: 'GillSans-Italic' }}>GillSans-Italic </option>

                                    <option value='GillSans-Light' style={{ fontFamily: 'GillSans-Light' }}>GillSans-Light </option>

                                    <option value='GillSans-LightItalic' style={{ fontFamily: 'GillSans-LightItalic' }}>GillSans-LightItalic </option>

                                    <option value='GillSans-SemiBold' style={{ fontFamily: 'GillSans-SemiBold' }}>GillSans-SemiBold </option>

                                    <option value='GillSans-SemiBoldItalic' style={{ fontFamily: 'GillSans-SemiBoldItalic' }}>GillSans-SemiBoldItalic </option>

                                    <option value='GillSans-UltraBold' style={{ fontFamily: 'GillSans-UltraBold' }}>GillSans-UltraBold </option>


                                    <option value='Heiti SC' style={{ fontFamily: 'Heiti SC' }}>Heiti SC </option>

                                    <option value='Heiti TC' style={{ fontFamily: 'Heiti TC' }}>Heiti TC </option>

                                    <option value='Helvetica' style={{ fontFamily: 'Helvetica' }}>Helvetica </option>

                                    <option value='Helvetica Neue' style={{ fontFamily: 'Helvetica Neue' }}>Helvetica Neue </option>

                                    <option value='Helvetica-Bold' style={{ fontFamily: 'Helvetica-Bold' }}>Helvetica-Bold </option>

                                    <option value='Helvetica-BoldOblique' style={{ fontFamily: 'Helvetica-BoldOblique' }}>Helvetica-BoldOblique </option>

                                    <option value='Helvetica-Light' style={{ fontFamily: 'Helvetica-Light' }}>Helvetica-Light </option>

                                    <option value='Helvetica-LightOblique' style={{ fontFamily: 'Helvetica-LightOblique' }}>Helvetica-LightOblique </option>

                                    <option value='Helvetica-Oblique' style={{ fontFamily: 'Helvetica-Oblique' }}>Helvetica-Oblique </option>

                                    <option value='HelveticaNeue-Bold' style={{ fontFamily: 'HelveticaNeue-Bold' }}>HelveticaNeue-Bold </option>

                                    <option value='HelveticaNeue-BoldItalic' style={{ fontFamily: 'HelveticaNeue-BoldItalic' }}>HelveticaNeue-BoldItalic </option>

                                    <option value='HelveticaNeue-CondensedBlack' style={{ fontFamily: 'HelveticaNeue-CondensedBlack' }}>HelveticaNeue-CondensedBlack </option>

                                    <option value='HelveticaNeue-CondensedBold' style={{ fontFamily: 'HelveticaNeue-CondensedBold' }}>HelveticaNeue-CondensedBold </option>

                                    <option value='HelveticaNeue-Italic' style={{ fontFamily: 'HelveticaNeue-Italic' }}>HelveticaNeue-Italic </option>

                                    <option value='HelveticaNeue-Light' style={{ fontFamily: 'HelveticaNeue-Light' }}>HelveticaNeue-Light </option>

                                    <option value='HelveticaNeue-LightItalic' style={{ fontFamily: 'HelveticaNeue-LightItalic' }}>HelveticaNeue-LightItalic </option>

                                    <option value='HelveticaNeue-Medium' style={{ fontFamily: 'HelveticaNeue-Medium' }}>HelveticaNeue-Medium </option>

                                    <option value='HelveticaNeue-MediumItalic' style={{ fontFamily: 'HelveticaNeue-MediumItalic' }}>HelveticaNeue-MediumItalic </option>

                                    <option value='HelveticaNeue-Thin' style={{ fontFamily: 'HelveticaNeue-Thin' }}>HelveticaNeue-Thin </option>

                                    <option value='HelveticaNeue-ThinItalic' style={{ fontFamily: 'HelveticaNeue-ThinItalic' }}>HelveticaNeue-ThinItalic </option>

                                    <option value='HelveticaNeue-UltraLight' style={{ fontFamily: 'HelveticaNeue-UltraLight' }}>HelveticaNeue-UltraLight </option>

                                    <option value='HelveticaNeue-UltraLightItalic' style={{ fontFamily: 'HelveticaNeue-UltraLightItalic' }}>HelveticaNeue-UltraLightItalic </option>

                                    <option value='Hiragino Mincho ProN' style={{ fontFamily: 'Hiragino Mincho ProN' }}>Hiragino Mincho ProN </option>

                                    <option value='Hiragino Sans' style={{ fontFamily: 'Hiragino Sans' }}>Hiragino Sans </option>

                                    <option value='HiraginoSans-W3' style={{ fontFamily: 'HiraginoSans-W3' }}>HiraginoSans-W3 </option>

                                    <option value='HiraginoSans-W6' style={{ fontFamily: 'HiraginoSans-W6' }}>HiraginoSans-W6 </option>

                                    <option value='HiraMinProN-W3' style={{ fontFamily: 'HiraMinProN-W3' }}>HiraMinProN-W3 </option>

                                    <option value='HiraMinProN-W6' style={{ fontFamily: 'HiraMinProN-W6' }}>HiraMinProN-W6 </option>

                                    <option value='Hoefler Text' style={{ fontFamily: 'Hoefler Text' }}>Hoefler Text </option>

                                    <option value='HoeflerText-Black' style={{ fontFamily: 'HoeflerText-Black' }}>HoeflerText-Black </option>

                                    <option value='HoeflerText-BlackItalic' style={{ fontFamily: 'HoeflerText-BlackItalic' }}>HoeflerText-BlackItalic </option>

                                    <option value='HoeflerText-Italic' style={{ fontFamily: 'HoeflerText-Italic' }}>HoeflerText-Italic </option>

                                    <option value='HoeflerText-Regular' style={{ fontFamily: 'HoeflerText-Regular' }}>HoeflerText-Regular </option>


                                    <option value='Kailasa' style={{ fontFamily: 'Kailasa' }}>Kailasa </option>

                                    <option value='Kailasa-Bold' style={{ fontFamily: 'Kailasa-Bold' }}>Kailasa-Bold </option>


                                    <option value='Khmer Sangam MN' style={{ fontFamily: 'Khmer Sangam MN' }}>Khmer Sangam MN </option>


                                    <option value='Lao Sangam MN' style={{ fontFamily: 'Lao Sangam MN' }}>Lao Sangam MN </option>


                                    <option value='Marker Felt' style={{ fontFamily: 'Marker Felt' }}>Marker Felt </option>

                                    <option value='MarkerFelt-Thin' style={{ fontFamily: 'MarkerFelt-Thin' }}>MarkerFelt-Thin </option>

                                    <option value='MarkerFelt-Wide' style={{ fontFamily: 'MarkerFelt-Wide' }}>MarkerFelt-Wide </option>

                                    <option value='Menlo' style={{ fontFamily: 'Menlo' }}>Menlo </option>

                                    <option value='Menlo-Bold' style={{ fontFamily: 'Menlo-Bold' }}>Menlo-Bold </option>

                                    <option value='Menlo-BoldItalic' style={{ fontFamily: 'Menlo-BoldItalic' }}>Menlo-BoldItalic </option>

                                    <option value='Menlo-Italic' style={{ fontFamily: 'Menlo-Italic' }}>Menlo-Italic </option>

                                    <option value='Menlo-Regular' style={{ fontFamily: 'Menlo-Regular' }}>Menlo-Regular </option>

                                    <option value='Mishafi' style={{ fontFamily: 'Mishafi' }}>Mishafi </option>

                                    <option value='Noteworthy' style={{ fontFamily: 'Noteworthy' }}>Noteworthy </option>

                                    <option value='Noteworthy-Bold' style={{ fontFamily: 'Noteworthy-Bold' }}>Noteworthy-Bold </option>

                                    <option value='Noteworthy-Light' style={{ fontFamily: 'Noteworthy-Light' }}>Noteworthy-Light </option>

                                    <option value='Optima' style={{ fontFamily: 'Optima' }}>Optima </option>

                                    <option value='Optima-Bold' style={{ fontFamily: 'Optima-Bold' }}>Optima-Bold </option>

                                    <option value='Optima-BoldItalic' style={{ fontFamily: 'Optima-BoldItalic' }}>Optima-BoldItalic </option>

                                    <option value='Optima-ExtraBlack' style={{ fontFamily: 'Optima-ExtraBlack' }}>Optima-ExtraBlack </option>

                                    <option value='Optima-Italic' style={{ fontFamily: 'Optima-Italic' }}>Optima-Italic </option>

                                    <option value='Optima-Regular' style={{ fontFamily: 'Optima-Regular' }}>Optima-Regular </option>


                                    <option value='Palatino' style={{ fontFamily: 'Palatino' }}>Palatino </option>

                                    <option value='Palatino-Bold' style={{ fontFamily: 'Palatino-Bold' }}>Palatino-Bold </option>

                                    <option value='Palatino-BoldItalic' style={{ fontFamily: 'Palatino-BoldItalic' }}>Palatino-BoldItalic </option>

                                    <option value='Palatino-Italic' style={{ fontFamily: 'Palatino-Italic' }}>Palatino-Italic </option>

                                    <option value='Palatino-Roman' style={{ fontFamily: 'Palatino-Roman' }}>Palatino-Roman </option>

                                    <option value='Papyrus' style={{ fontFamily: 'Papyrus' }}>Papyrus </option>

                                    <option value='Papyrus-Condensed' style={{ fontFamily: 'Papyrus-Condensed' }}>Papyrus-Condensed </option>

                                    <option value='Party LET' style={{ fontFamily: 'Party LET' }}>Party LET </option>

                                    <option value='PartyLetPlain' style={{ fontFamily: 'PartyLetPlain' }}>PartyLetPlain </option>





                                    <option value='Savoye LET' style={{ fontFamily: 'Savoye LET' }}>Savoye LET </option>

                                    <option value='SavoyeLetPlain' style={{ fontFamily: 'SavoyeLetPlain' }}>SavoyeLetPlain </option>

                                    <option value='Sinhala Sangam MN' style={{ fontFamily: 'Sinhala Sangam MN' }}>Sinhala Sangam MN </option>

                                    <option value='SinhalaSangamMN' style={{ fontFamily: 'SinhalaSangamMN' }}>SinhalaSangamMN </option>

                                    <option value='SinhalaSangamMN-Bold' style={{ fontFamily: 'SinhalaSangamMN-Bold' }}>SinhalaSangamMN-Bold </option>

                                    <option value='Snell Roundhand' style={{ fontFamily: 'Snell Roundhand' }}>Snell Roundhand </option>

                                    <option value='SnellRoundhand-Black' style={{ fontFamily: 'SnellRoundhand-Black' }}>SnellRoundhand-Black </option>

                                    <option value='SnellRoundhand-Bold' style={{ fontFamily: 'SnellRoundhand-Bold' }}>SnellRoundhand-Bold </option>

                                    <option value='Symbol' style={{ fontFamily: 'Symbol' }}>Symbol </option>


                                    <option value='Thonburi' style={{ fontFamily: 'Thonburi' }}>Thonburi </option>

                                    <option value='Thonburi-Bold' style={{ fontFamily: 'Thonburi-Bold' }}>Thonburi-Bold </option>

                                    <option value='Thonburi-Light' style={{ fontFamily: 'Thonburi-Light' }}>Thonburi-Light </option>

                                    <option value='Times New Roman' style={{ fontFamily: 'Times New Roman' }}>Times New Roman </option>

                                    <option value='TimesNewRomanPS-BoldItalicMT' style={{ fontFamily: 'TimesNewRomanPS-BoldItalicMT' }}>TimesNewRomanPS-BoldItalicMT </option>

                                    <option value='TimesNewRomanPS-BoldMT' style={{ fontFamily: 'TimesNewRomanPS-BoldMT' }}>TimesNewRomanPS-BoldMT </option>

                                    <option value='TimesNewRomanPS-ItalicMT' style={{ fontFamily: 'TimesNewRomanPS-ItalicMT' }}>TimesNewRomanPS-ItalicMT </option>

                                    <option value='TimesNewRomanPSMT' style={{ fontFamily: 'TimesNewRomanPSMT' }}>TimesNewRomanPSMT </option>

                                    <option value='Trebuchet MS' style={{ fontFamily: 'Trebuchet MS' }}>Trebuchet MS </option>

                                    <option value='Trebuchet-BoldItalic' style={{ fontFamily: 'Trebuchet-BoldItalic' }}>Trebuchet-BoldItalic </option>

                                    <option value='TrebuchetMS-Bold' style={{ fontFamily: 'TrebuchetMS-Bold' }}>TrebuchetMS-Bold </option>

                                    <option value='TrebuchetMS-Italic' style={{ fontFamily: 'TrebuchetMS-Italic' }}>TrebuchetMS-Italic </option>

                                    <option value='Verdana' style={{ fontFamily: 'Verdana' }}>Verdana </option>

                                    <option value='Verdana-Bold' style={{ fontFamily: 'Verdana-Bold' }}>Verdana-Bold </option>

                                    <option value='Verdana-BoldItalic' style={{ fontFamily: 'Verdana-BoldItalic' }}>Verdana-BoldItalic </option>

                                    <option value='Verdana-Italic' style={{ fontFamily: 'Verdana-Italic' }}>Verdana-Italic </option>

                                    <option value='Zapf Dingbats' style={{ fontFamily: 'Zapf Dingbats' }}>Zapf Dingbats </option>

                                    <option value='ZapfDingbatsITC' style={{ fontFamily: 'ZapfDingbatsITC' }}>ZapfDingbatsITC </option>

                                    <option value='Zapfino' style={{ fontFamily: 'Zapfino' }}>Zapfino </option>
                                </select>
                            </div> */}



                            <div className="my-3 text-center"><b>Arrow Type</b></div>
                            <div className="row d-flex justify-content-center mb-1 mx-2 ">
                                <div className=''>
                                    <div
                                        onClick={event => {
                                            setArrowType(1);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 1 ? "select" : "false"}`}
                                            aria-label="Next Item"
                                            tabindex="0"
                                            data-hook="nav-arrow-next"
                                            style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 24.725px)', right: '10px' }}
                                        >
                                            <svg
                                                className="slideshow-arrow"
                                                style={{ transform: 'scaleX(1) scale(1.65)' }}
                                                width="28px"
                                                height="28px"
                                                viewBox="0 0 40 33"
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns-xlink="http://www.w3.org/1999/xlink"
                                            >
                                                <g stroke="none" stroke-width="1" fill-rule="evenodd">
                                                    <g
                                                        transform="translate(-28.000000, -32.000000)"
                                                        stroke-width="nonzero"
                                                    >
                                                        <polygon
                                                            transform="translate(47.800000, 48.469489) rotate(-180.000000) translate(-47.800000, -48.469489) "
                                                            points="43.2916087 32 44.4061622 33.1660321 30.8430707 47.6817192 67.6 47.6813756 67.6 49.2576026 30.9452714 49.2580761 44.4061622 63.772946 43.2924258 64.9389782 28.8681974 49.4277178 28 48.5197421"
                                                        ></polygon>
                                                    </g>
                                                </g>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className=''>
                                    <div
                                        className={arrowType === 2 ? true : false}
                                        onClick={event => {
                                            setArrowType(2);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 2 ? "select" : "false"}`} aria-label="Next Item" tabindex="0" data-hook="nav-arrow-next"
                                            style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 6.80769px)', right: '28px' }}><svg className="slideshow-arrow"
                                                style={{ transform: 'scaleX(1) scale(1.65)' }} width="28px" height="28px" viewBox="0 0 39 11" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                xmlns-xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fillRule="evenodd"><g transform="translate(-29.000000, -43.000000)"
                                                    fillRule="nonzero"><polygon points="59.79296 43 67.1767272 48.2074587 59.79296 53.3482492 59.792 49.24 29 49.2402303 29 47.3156703 59.792 47.315"></polygon></g></g></svg></button>
                                    </div>

                                </div>
                                <div className=''>
                                    <div
                                        className={arrowType === 3 ? true : false}
                                        onClick={event => {
                                            setArrowType(3);
                                        }}
                                    > <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 3 ? "select" : "false"}`}
                                        aria-label="Next Item" tabindex="0" data-hook="nav-arrow-next"
                                        style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 52.94px)', right: '28px' }}>
                                            <svg className="slideshow-arrow" style={{ transform: 'scaleX(1) scale(1.64)' }} width="28px" height="28px" viewBox="0 0 25 42"
                                                version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns-xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fillRule="evenodd"><g id="Artboard-Copy-97" transform="translate(-36.000000, -27.000000)" fillRule="nonzero"><path d="M37.2206398,28.239114 C38.8026583,26.647265 41.3436172,26.5881667 42.9967317,28.0675785 L43.1590153,28.2206482 L59.1611748,44.1233571 C61.1319602,46.0819718 61.1995454,49.2312919 59.3527322,51.2754674 L59.1795659,51.4581932 L43.1590166,67.3793505 C41.51408,69.0140701 38.8553922,69.0057967 37.2206146,67.3608606 C35.638653,65.7689547 35.5953873,63.2276769 37.0850712,61.5838107 L37.2391492,61.4224839 L50.946,47.799 L37.2391492,34.1775161 C35.7003375,32.6482622 35.5938031,30.2229032 36.9247365,28.5696317 L37.0675472,28.4014262 L37.2206398,28.239114 Z" id="8"></path></g></g></svg></button>
                                    </div>
                                </div>
                                <div className=''>
                                    <div
                                        className={arrowType === 4 ? true : false}
                                        onClick={event => {
                                            setArrowType(4);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 4 ? "select" : "false"}`} aria-label="Previous Item" tabindex="0" data-hook="nav-arrow-back"
                                            style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 18.6538px)', right: '28px' }}><svg className="slideshow-arrow"
                                                style={{ transform: 'scaleX(1) scale(1.69231)' }} width="28px" height="28px" viewBox="0 0 39 25" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                xmlns-xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill-rule="evenodd"><g transform="translate(-29.000000, -36.000000)"
                                                    fillRule="nonzero"><path d="M29,48.2400242 C29,47.3087892 29.6817196,46.6578788 30.6657131,46.6578788 L62.0721815,46.6578788 L53.6034603,38.6027842 C52.9919732,38.0244263 52.9745394,37.0965804 53.5626533,36.4993057 L53.6196503,36.4424086 C54.2232252,35.8695838 55.2162345,35.8487051 55.8566495,36.4049822 L66.7354947,46.6987178 C66.8997789,46.8532785 67.0362567,47.0299812 67.1410943,47.2233734 C67.6421069,47.9137524 67.5952684,48.7577348 67.0654839,49.3382112 L66.9183084,49.529704 C66.8745903,49.5829565 66.834409,49.6278886 66.7923536,49.6712745 L55.84922,60.0371144 C55.2232594,60.6516206 54.1974244,60.6696143 53.554893,60.0838114 C52.9168128,59.5020667 52.8980482,58.5443858 53.5126939,57.940867 L53.5761731,57.877497 L62.0800244,49.8549119 L30.6657131,49.8549119 C29.6912419,49.8549119 29,49.1805348 29,48.2400242 Z" id="5"></path></g></g></svg></button>
                                    </div>
                                </div>
                                <div className=''>
                                    <div
                                        className={arrowType === 5 ? true : false}
                                        onClick={event => {
                                            setArrowType(5);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 5 ? "select" : "false"}`} aria-label="Next Item" tabindex="0" data-hook="nav-arrow-next" style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 6.9875px)', left: '28px' }}><svg className="slideshow-arrow" style={{ transform: 'scaleX(1) scale(0.575)' }} width="28px" height="28px" viewBox="0 0 40 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns-xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fillRule="evenodd"><g transform="translate(-28.000000, -32.000000)" stroke-width="nonzero"><polygon transform="translate(47.800000, 48.469489) rotate(-180.000000) translate(-47.800000, -48.469489) " points="43.2916087 32 44.4061622 33.1660321 30.8430707 47.6817192 67.6 47.6813756 67.6 49.2576026 30.9452714 49.2580761 44.4061622 63.772946 43.2924258 64.9389782 28.8681974 49.4277178 28 48.5197421"></polygon></g></g></svg></button>
                                    </div>
                                </div>
                                <div className=''>
                                    <div
                                        className={arrowType === 6 ? true : false}
                                        onClick={event => {
                                            setArrowType(6);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 6 ? "select" : "false"}`} aria-label="Next Item" tabindex="0" data-hook="nav-arrow-next"
                                            style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 24.725px)', right: '28px' }}><svg className="slideshow-arrow"
                                                style={{ transform: 'scaleX(1) scale(1.65)' }} width="28px" height="28px" viewBox="0 0 26 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns-xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill-rule="evenodd">
                                                    <g transform="translate(-35.000000, -28.000000)" fillRule="nonzero"><polygon
                                                        points="60.4571429 47.8 40.6571429 67.6 35 61.9428571 49.1433951 47.7994621 35 33.6571429 40.6571429 28"></polygon></g></g></svg>
                                        </button>
                                    </div>
                                </div>
                                <div className=''>
                                    <div
                                        className={arrowType === 0 ? true : false}
                                        onClick={event => {
                                            setArrowType(0);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 0 ? "select" : "false"}`} aria-label="Next Item" tabindex="0" data-hook="nav-arrow-next" style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 17px)', right: '28px' }}><svg className="slideshow-arrow" style={{ transform: 'scaleX(1) scale(1)' }} width="28" height="28" viewBox="0 0 23 39"><path d="M857.005,231.479L858.5,230l18.124,18-18.127,18-1.49-1.48L873.638,248Z" transform="translate(-855 -230)"></path></svg></button>
                                    </div>
                                </div>
                            </div>

                            <div className="my-2 mt-3 text-center"><b>Arrow Size</b></div>

                            <div className="mb-1 text-center">
                                <b>Size</b>
                                <br />
                                <div className='d-flex justify-content-center'>
                                    <input className='input_sty' defaultValue={setting.arrowSize} style={InputStlye} type='range' value={arrowSize} min='0' max='200' onChange={e => setArrowSize(e.target.value)}></input> <span className='ml-3 arrowSize'>{arrowSize} </span></div>
                            </div>
                            <div className="my-2 mt-3 text-center"><b>Arrow Color</b></div>
                            <div style={{ padding: '0 5%' }}>


                                <Row>

                                    <Colxx xxs="12">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-3'></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                setArrowColor(e.target.value);
                                                            }}
                                                            value={arrowColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, arrowColor: !iseditMode.arrowColor });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(arrowColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.arrowColor && <div className='parent-div d-flex justify-content-center'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={arrowColor}
                                                    onChangeComplete={(e) => {
                                                        if (edit) {
                                                            setArrowColor(e.hex);
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>

                                </Row>
                            </div>
                            <div className="my-2 mt-3 text-center"><b> Display Services</b></div>
                            <div className="mb-1 text-center">
                                <div className='d-flex justify-content-center'>
                                    <Input className='input_sty' defaultValue={setting.displayServices} style={InputStlye} type='select'
                                        value={displayServices} min='0' max='200' onChange={e => setDisplayServices(e.target.value)}>
                                        <option value="0">Random Rotation</option>
                                        <option value="1">As Per Service Order Defined</option>
                                    </Input>
                                </div>
                            </div>
                            <Row className="my-2">
                                <Colxx xxs="6">
                                    <div>
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className='col-md-6 text-left' style={{ marginTop: '0.30rem' }}>
                                                <span className=''><b>Button Text Color</b></span>
                                            </div>
                                            <div className='col-md-6'>
                                                <InputGroup>
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        onChange={(e) => {
                                                            let colours = setting.colours;
                                                            colours.buttonTextColor = e.target.value;
                                                            setSetting({ ...setting, colours: colours });
                                                        }}
                                                        value={setting.colours.buttonTextColor}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, buttonTextColor: !iseditMode.buttonTextColor });
                                                        }} className="color-square" style={setBackGroundColor(setting.colours.buttonTextColor)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.buttonTextColor && <div className='parent-div'>
                                        <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                            <ChromePicker disableAlpha={true} className='ml-2'
                                                style={{ width: '240px' }}
                                                color={setting.colours.buttonTextColor}
                                                onChangeComplete={(e) => {

                                                    if (edit) {
                                                        let colours = setting.colours;
                                                        colours.buttonTextColor = e.hex;
                                                        setSetting({ ...setting, colours: colours });
                                                    } else setError(true);
                                                }}
                                            />
                                        </div>
                                    </div>}
                                </Colxx>
                                <Colxx xxs="6">
                                    <div>
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className='col-md-6 text-left' style={{ marginTop: '0.30rem' }}>
                                                <span className=''><b>Redeem Text Color</b></span>
                                            </div>
                                            <div className='col-md-6'>
                                                <InputGroup>
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        onChange={(e) => {
                                                            let colours = setting.colours;
                                                            colours.redeemTextColor = e.target.value;
                                                            setSetting({ ...setting, colours: colours });
                                                        }}
                                                        value={setting.colours.redeemTextColor}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, redeemTextColor: !iseditMode.redeemTextColor });
                                                        }
                                                        } className="color-square" style={setBackGroundColor(setting.colours.redeemTextColor)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.redeemTextColor &&
                                        <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.redeemTextColor}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.redeemTextColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                </Colxx>
                                <Colxx xxs="6">
                                    <div>
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className='col-md-6 text-left' style={{
                                                marginTop: '0.30rem'
                                            }}>
                                                <span className=''><b>Primary Color</b></span>
                                            </div>
                                            <div className='col-md-6'>
                                                <InputGroup>
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        onChange={(e) => {
                                                            let colours = setting.colours;
                                                            colours.primaryColor = e.target.value;
                                                            setSetting({ ...setting, colours: colours });
                                                        }}
                                                        value={setting.colours.primaryColor}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, primaryColor: !iseditMode.primaryColor });
                                                        }
                                                        } className="color-square" style={setBackGroundColor(setting.colours.primaryColor)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.primaryColor &&
                                        <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.primaryColor}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.primaryColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }}
                                                />
                                            </div>
                                        </div>}
                                </Colxx>
                                <Colxx xxs="6">
                                    <div>
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className='col-md-6 text-left' style={{
                                                marginTop: '0.30rem'
                                            }}>
                                                <span className=''><b>Button Color</b></span>
                                            </div>
                                            <div className='col-md-6'>
                                                <InputGroup>
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        onChange={(e) => {
                                                            let colours = setting.colours;
                                                            colours.buttonColor = e.target.value;
                                                            setSetting({ ...setting, colours: colours });
                                                        }}
                                                        value={setting.colours.buttonColor}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, buttonColor: !iseditMode.buttonColor });
                                                        }} className="color-square" style={setBackGroundColor(setting.colours.buttonColor)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.buttonColor &&
                                        <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.buttonColor}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.buttonColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }}
                                                />
                                            </div>
                                        </div>}
                                </Colxx>
                                <Colxx xxs="6">
                                    <div >
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className='col-md-6 text-left' style={{
                                                marginTop: '0.30rem'
                                            }}>
                                                <span className=''><b>Redeem Bar</b></span>
                                            </div>
                                            <div className='col-md-6'>
                                                <InputGroup>
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        onChange={(e) => {
                                                            let colours = setting.colours;
                                                            colours.redeemBar = e.target.value;
                                                            setSetting({ ...setting, colours: colours });
                                                        }}
                                                        value={setting.colours.redeemBar}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, redeemBar: !iseditMode.redeemBar });
                                                        }} className="color-square" style={setBackGroundColor(setting.colours.redeemBar)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.redeemBar && <div className='parent-div'>
                                        <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                            <ChromePicker disableAlpha={true} className='ml-2'
                                                style={{ width: '240px' }}
                                                color={setting.colours.redeemBar}
                                                onChangeComplete={(e) => {

                                                    if (edit) {
                                                        let colours = setting.colours;
                                                        colours.redeemBar = e.hex;
                                                        setSetting({ ...setting, colours: colours });
                                                    } else setError(true);
                                                }
                                                }
                                            />
                                        </div>
                                    </div>}
                                </Colxx>
                                <Colxx xxs="6">
                                    <div >
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className='col-md-6 text-left' style={{
                                                marginTop: '0.30rem'
                                            }}>
                                                <span className=''><b>Redeem Button</b></span>
                                            </div>
                                            <div className='col-md-6'>
                                                <InputGroup>
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        onChange={(e) => {
                                                            let colours = setting.colours;
                                                            colours.redeemButton = e.target.value;
                                                            setSetting({ ...setting, colours: colours });
                                                        }}
                                                        value={setting.colours.redeemButton}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, redeemButton: !iseditMode.redeemButton });
                                                        }
                                                        } className="color-square" style={setBackGroundColor(setting.colours.redeemButton)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.redeemButton && <div className='parent-div'>
                                        <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                            <ChromePicker disableAlpha={true} className='ml-2'
                                                style={{ width: '240px' }}
                                                color={setting.colours.redeemButton}
                                                onChangeComplete={(e) => {

                                                    if (edit) {
                                                        let colours = setting.colours;
                                                        colours.redeemButton = e.hex;
                                                        setSetting({ ...setting, colours: colours });
                                                    } else setError(true);
                                                }
                                                }
                                            />
                                        </div>
                                    </div>}
                                </Colxx>
                                <Colxx xxs="6">
                                    <div >
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className=' col-md-6 text-left' style={{
                                                marginTop: '0.30rem'
                                            }}><b>Shopping Bar</b></div>
                                            < div className='col-md-6' >
                                                <InputGroup className="">
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        value={setting.colours.shoppingBar}

                                                        onChange={(e) => {
                                                            let colours = setting.colours;
                                                            colours.shoppingBar = e.target.value;
                                                            setSetting({ ...setting, colours: colours });
                                                        }}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, shoppingBar: !iseditMode.shoppingBar });
                                                        }} className="color-square" style={setBackGroundColor(setting.colours.shoppingBar)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.shoppingBar && <div className='parent-div'>
                                        <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                            <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                                                color={setting.colours.shoppingBar}
                                                name="subTitle"
                                                onChange={(e) => {
                                                    if (edit) {
                                                        let colours = setting.colours;
                                                        colours.shoppingBar = e.hex;
                                                        setSetting({ ...setting, colours: colours });
                                                    } else setError(true);
                                                }
                                                }
                                            />
                                        </div></div>}
                                </Colxx>
                                <Colxx xxs="6">
                                    <div >
                                        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                            <div className=' col-md-6  text-left' style={{
                                                marginTop: '0.30rem'
                                            }}><b>Shopping Bar Text</b></div>
                                            < div className='col-md-6' >
                                                <InputGroup className="">
                                                    <Input
                                                        className=""
                                                        type="text"
                                                        value={setting.colours.shoppingBarText}

                                                        onChange={(e) => {
                                                            let colours = setting.colours;
                                                            colours.shoppingBarText = e.target.value;
                                                            setSetting({ ...setting, colours: colours });
                                                        }}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={() => {
                                                            setEditMode({ ...iseditMode, shoppingBarText: !iseditMode.shoppingBarText });
                                                        }} className="color-square" style={setBackGroundColor(setting.colours.shoppingBarText)}></InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {iseditMode.shoppingBarText &&
                                        <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                                                    color={setting.colours.shoppingBarText}
                                                    name="subTitle"
                                                    onChange={(e) => {
                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.shoppingBarText = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    }
                                </Colxx>



                            </Row>
                            <div className="my-2 mt-3 text-center"><b>Font Settings</b></div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className="mb-1  row ">
                                        <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                            <b>Website Font Name </b>
                                        </div>
                                        <br />
                                        <div className="col-md-6">
                                            <FontsList InputStlye={SelectStyle} value={setting.font} settings={setting} setFont={(e) => setFont(e.target.value)}></FontsList>
                                        </div>
                                    </div>
                                </div>
                                {setting.fonts !== undefined && <Fragment>
                                    <div className=' col-md-6 '>
                                        <div className="mb-1  row">
                                            <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                                <b>Title Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-6">
                                                <FontsList InputStlye={SelectStyle} value={setting.fonts.title} settings={setting} setFont={(e) => setFontsList({ ...fontsList, title: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=' col-md-6 '>
                                        <div className="mb-1 row ">
                                            <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                                <b>Subtitle Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-6">
                                                <FontsList InputStlye={SelectStyle} value={setting.fonts.subTitle} settings={setting} setFont={(e) => setFontsList({ ...fontsList, subTitle: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=' col-md-6 '>
                                        <div className="mb-1 row ">
                                            <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                                <b>Button Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-6">
                                                <FontsList InputStlye={SelectStyle} value={setting.fonts.buttonText} settings={setting} setFont={(e) => setFontsList({ ...fontsList, buttonText: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=' col-md-6 '>
                                        <div className="mb-1 row ">
                                            <div className="col-md-6 text-left" style={{ marginTop: '1rem' }}>
                                                <b>Service Title Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-6">
                                                <FontsList InputStlye={SelectStyle} value={setting.fonts.serviceTitle} settings={setting} setFont={(e) => setFontsList({ ...fontsList, serviceTitle: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=' col-md-6 '>
                                        <div className="mb-1 row">
                                            <div className="col-md-6 text-left" style={{ marginTop: '1rem' }}>
                                                <b>Service Description Font </b>
                                            </div>
                                            <br />
                                            <div className="col-md-6">
                                                <FontsList InputStlye={SelectStyle} value={setting.fonts.serviceDescription} settings={setting} setFont={(e) => setFontsList({ ...fontsList, serviceDescription: e.target.value })}></FontsList>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>}
                            </div>
                            <div className='d-flex justify-content-center my-3'>
                                <CustomInput
                                    key="isFooterBmb"
                                    type="checkbox"
                                    checked={isFooterHide}
                                    onChange={(e) => e.target.checked === true ? setIsFooterHide(true) : setIsFooterHide(false)}
                                ><span>Hide "Powered by bmb"</span></CustomInput>
                            </div>
                            <div className='d-flex justify-content-center my-3'>
                                <Button
                                    size="xs"
                                    color="dark"
                                    outline
                                    onClick={() => {
                                        handleColoursReset();
                                    }}
                                >
                                    Reset to default font and colors
                                </Button>
                            </div>
                        </div>

                        <div className='text-center'>
                            <ButtonGroup className="mb-2 " style={{ marginTop: '40px' }}>
                                <Button color="primary" size="xs" onClick={handleSave}>
                                    Save
                                </Button>
                                <Button
                                    size="xs"
                                    color="dark"

                                    onClick={() => {
                                        CloseColorBox();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </ButtonGroup>
                        </div>
                    </CardBody>
                </Card >
            ) : null
            }
            {ImageGalleryButton()}

        </Fragment >
    );
}

